import { RelationshipType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";

export const accountRelationships = [
  RelationshipType.AccountHolder,
  RelationshipType.AccountHolderFor
];
